import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IonIcon } from "@/components/icons/AppIcon";
import Logo from "@/components/Logo";
import { LoginButton, OpenAppButton } from "@/components/AppButtons";

const NAV = [
  { label: "Functies", id: "functies", hash: "#features" },
  { label: "Binnenkort", id: "binnenkort", hash: "#binnenkort" },
  { label: "Op de computer", id: "computer", hash: "#computer" },
  { label: "Schermen", id: "schermen", hash: "#screenshots" },
  { label: "Support", id: "support", hash: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (hash) => {
    setOpen(false);
    if (location.pathname !== "/") navigate("/" + hash);
    else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled || open
          ? "border-b border-[#2C2E29] bg-[#121311]/90 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-5 py-3 md:px-10">
        <Logo onClick={() => setOpen(false)} />

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => go(item.hash)}
              className="text-sm font-medium text-[#B5B8B0] transition-colors hover:text-[#E0BE82]"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-3 md:flex">
            <LoginButton testid="header-login-btn" className="py-2.5" />
            <OpenAppButton testid="header-open-waidbook-btn" className="py-2.5" />
          </div>

          <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-[#2C2E29] bg-[#1C1D1A] text-[#EAEBE7] lg:hidden"
          aria-label="Menu openen"
        >
          <IonIcon name={open ? "close" : "menu"} size={20} />
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-[#2C2E29] lg:hidden">
          <nav className="flex flex-col px-5 pb-6 pt-2">
            {NAV.map((item) => (
              <button
                key={item.id}
                data-testid={`mobile-nav-${item.id}`}
                onClick={() => go(item.hash)}
                className="border-b border-[#2C2E29] py-4 text-left text-base font-medium text-[#EAEBE7]"
              >
                {item.label}
              </button>
            ))}
            <div className="mt-5 grid grid-cols-2 gap-3 md:hidden">
              <LoginButton testid="mobile-login-btn" />
              <OpenAppButton testid="mobile-open-waidbook-btn" />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
